export class ActionChangeComponentProperty {
  private component: any;
  private propName: string;
  private oldValue: any;
  private newValue: any;

  constructor(component:any, propName: string, newValue:any, oldValue?: any) {
    this.component = component;
    this.propName = propName;
    this.newValue = newValue;
    this.oldValue = oldValue;
  }

  execute() {
    if (this.oldValue === undefined)
      this.oldValue = this.component[this.propName];
    this.component[this.propName] = this.newValue;
  }

  undo() {
    this.component[this.propName] = this.oldValue;
  }

  toString() {
    return "Change " + this.component.constructor.name + "." + this.propName;
  }
}
